import type { ProjectRecord } from "./project-records.ts";
import type { WelcomePage } from "./welcome.ts";

/**
 * Opening an example that this browser keeps a copy of asks first: continue
 * with that copy, or start over with a new one. The old copy stays under
 * Recent projects either way. See "Example Links" in the page's README.
 */
export interface CopyChoice {
    /** The copy kept from the example, the one opened last. */
    kept: ProjectRecord;
    /** Open the kept copy. */
    proceed(): void;
    /** Open a new copy of the example. */
    startOver(): void;
}

/** The welcome window's page that asks. */
export function copyPage(choice: CopyChoice): WelcomePage {
    return {
        heading: `Continue ${choice.kept.name}?`,
        render: (close) => {
            const page = document.createElement("div");
            page.className = "idfweb-welcome-list";
            const text = document.createElement("p");
            text.className = "idfweb-welcome-note";
            text.textContent = `This browser keeps a copy of this example, ${keptDetail(choice.kept)}.`;
            const proceed = entry(`Continue ${choice.kept.name}`, "Open the kept copy, with your changes.", () => {
                close();
                choice.proceed();
            });
            // What the dialog focuses when it opens, rather than its close button.
            proceed.autofocus = true;
            page.append(
                text,
                proceed,
                entry("Start over", "Open a new copy. The kept one stays under Recent projects.", () => {
                    close();
                    choice.startOver();
                }),
            );
            return page;
        },
    };
}

/** When the kept copy was opened last, for a button's tooltip or a note. */
export function keptDetail(record: ProjectRecord): string {
    return `opened ${new Date(record.opened).toLocaleString()}`;
}

function entry(title: string, detail: string, click: () => void): HTMLButtonElement {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "idfweb-welcome-entry";
    const titleText = document.createElement("span");
    titleText.className = "title";
    titleText.textContent = title;
    const detailText = document.createElement("span");
    detailText.className = "detail";
    detailText.textContent = detail;
    button.append(titleText, detailText);
    button.addEventListener("click", click);
    return button;
}
